import clsx from "clsx";
import { Color } from "@/domains/dialogue/constants/color";

type Props = {
  color?: Color;
  id: number;
  text: string;
  isActive?: boolean;
  className?: string;
  onClick: (id: number) => void;
};

export default function DialogueAnswerButton({
  color,
  id,
  text,
  className,
  isActive,
  onClick,
}: Props) {
  return (
    <button
      type="button"
      className={clsx(
        "group h-[2.5rem] p-[1px] rounded-[0.5rem]",
        "bg-white/10 bg-gradient-to-r to-transparent",
        {
          "hover:from-[#FF4E4E] hover:via-[30%] hover:via-[#FF4E4E]/30": color === Color.Default,
          "hover:from-[#FF9A5C] hover:via-[30%] hover:via-[#FF9A5C]/30": color === Color.Yellow,
          "hover:from-[#5FFF69] hover:via-[30%] hover:via-[#5FFF69]/30": color === Color.Green,
          "from-[#FF4E4E] via-[30%] via-[#FF4E4E]/30": color === Color.Default && isActive,
          "from-[#FF9A5C] via-[30%] via-[#FF9A5C]/30": color === Color.Yellow && isActive,
          "from-[#5FFF69] via-[30%] via-[#5FFF69]/30": color === Color.Green && isActive,
        },
        "transition-all active:scale-95",
        className,
      )}
      onClick={() => onClick(id)}
    >
      <div
        className={clsx(
          "h-full w-full flex items-center gap-2.5 p-2 bg-dark-900 rounded-[0.45rem]",
          "bg-gradient-to-r to-transparent",
          {
            "group-hover:from-[#AB2929]/40 group-hover:via-[30%] group-hover:via-[#AB2929]/10":
              color === Color.Default,
            "group-hover:from-[#FF9A5C]/40 group-hover:via-[30%] group-hover:via-[#FF9A5C]/10":
              color === Color.Yellow,
            "group-hover:from-[#21652C]/40 group-hover:via-[30%] group-hover:via-[#21652C]/10 ":
              color === Color.Green,
            "from-[#AB2929]/40 via-[30%] via-[#AB2929]/10": color === Color.Default && isActive,
            "from-[#FF9A5C]/40 via-[30%] via-[#FF9A5C]/10": color === Color.Yellow && isActive,
            "from-[#21652C]/40 via-[30%] via-[#21652C]/10 ": color === Color.Green && isActive,
          },
          "transition-all",
        )}
      >
        <div
          className={clsx(
            "h-[1.5rem] aspect-square shrink-0 rounded-[0.375rem]",
            "flex items-center justify-center gap-2.5",
            "bg-gradient-to-r bg-white",
            {
              "group-hover:from-[#E53F3F] group-hover:to-[#AB2929]": color === Color.Default,
              "group-hover:from-[#FFB45C] group-hover:to-[#FF9A5C]": color === Color.Yellow,
              "group-hover:from-[#368D44] group-hover:to-[#21652C]": color === Color.Green,
              "from-[#E53F3F] to-[#AB2929]": color === Color.Default && isActive,
              "from-[#FFB45C] to-[#FF9A5C]": color === Color.Yellow && isActive,
              "from-[#368D44] to-[#21652C]": color === Color.Green && isActive,
            },

            "text-14 leading-3 text-dark-900 font-bold group-hover:text-white",
            "transition-all",
          )}
        >
          {id}
        </div>
        <div className="text-15 font-medium">{text}</div>
      </div>
    </button>
  );
}
